export default {
    pageName: 'Create Visitor',
    profile: {
        name: 'Profile',
        detail: 'Image size must be between 25KB and 200KB'
    },
    accessInfo: 'Access information',
    setupDetail: 'Set up time range per 1 day',
    passportId: {
        title: 'Citizen ID / Passport ID',
        placeholder: 'Enter Citizen ID / Passport ID '
    },
    name: {
        title: 'Name',
        placeholder: 'Enter Visitor Name',
        require: 'Name is required'
    },
    surname: {
        title: 'Surname',
        placeholder: 'Enter Visitor Surname',
        require: 'Surname is required'
    },
    gender: {
        title: 'Gender',
        male: 'Male',
        female: 'Female'
    },
    visitAt: {
        title: 'Visit At',
        placeholder: '- Select Bureau -',
        require: 'Visit At is required'
    },
    email: {
        title: 'Email address',
        placeholder: 'Enter Email address',
        invalid: 'Invalid Email address',
        require: 'Email address is required'
    },
    phone: {
        title: 'Phone Number',
        placeholder: ' 00 000 0000',
        invalid: 'Invalid Phone number',
        require: 'Phone Number is required'
    },
    operator: {
        title: 'Operator',
        require: 'Operator is required',
        placeholder: 'Enter Operator',
        detail: 'Enter Employee ID to send notification (Via Line) when visitor arrived.',
        btnClose: 'CLOSE'
    },
    uploadIdCard: {
        title: 'Upload ID Card',
        placeholder: 'JPG or PNG max size 10 MB',
        require: 'Upload ID Card is required'
    },
    startTime: {
        title: 'Start Time',
        placeholder: '- - : - -',
        require: 'Start Time is required'
    },
    endTime: {
        title: 'End Time',
        placeholder: '- - : - -',
        require: 'End Time is required'
    },
    button: {
        cancel: 'Cancel',
        submit: 'Submit'
    },
    modalFail: {
        btnOk: 'CLOSE',
        titleFail: 'Failed',
        title: 'Warning',
        body: 'Not found visitor id ',
        bodyFile: 'Image size must be between 25KB and 200KB '
    },
    modalSuccess: {
        title: 'Success',
        body: 'Visitor has been saved',
        btnOk: 'CONFIRM'
    },
    idNumber: {
        titile: 'หมายเลขบัตรประชาชน',
        require: 'กรุณากรอกบัตรประชาชน/หนังสือเดินทาง'
    }
}
